<template>
  <transition name="fade">
    <div
      v-if="toast.visible"
      class="fixed bottom-5 right-5 max-w-sm flex items-center gap-3 py-3 px-4 rounded-xl shadow-lg text-white z-100000"
      :class="toastColors[toast.type].bg"
    >
      <component
        :is="toastColors[toast.type].icon"
        class="w-6 h-6 mt-0.5"
      />
      <span class="text-sm font-medium">{{ toast.message }}</span>
    </div>
  </transition>
</template>

<script setup>
import { toast } from '@/composables/useToast'

// Heroicons v2
import { CheckCircleIcon } from '@heroicons/vue/24/solid'
import { ExclamationTriangleIcon, XCircleIcon } from '@heroicons/vue/24/outline'

// Icon & background map by toast type
const toastColors = {
  success: {
    icon: CheckCircleIcon,
    bg: 'bg-green-600'
  },
  warning: {
    icon: ExclamationTriangleIcon,
    bg: 'bg-yellow-600'
  },
  danger: {
    icon: XCircleIcon,
    bg: 'bg-red-600'
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
